export const UNACADEMY_AI_PAGE = 'Unacademy AI - Doubts & Solutions';
export const EMPTY_CHAT_TEXT = 'How can I help you today?';
export const CHAT_IMAGE_INPUT_PLACEHOLDER =
  'Type or upload image of a question';
export const CHAT_INPUT_PLACEHOLDER = 'Type a question';

export const CHAT_LOST_TITLE = 'Chat history will be lost';
export const GO_BACK_CONFIRMATION_MESSAGE =
  'If you go back, you will lose your chat history.';

export const ASK_NEW_QUESTION_CONFIRMATION_MESSAGE =
  'Chat history will be lost if you ask a new question.';

export const CONTENT_TYPES = {
  IMAGE: 1,
  TEXT: 2
};
export const CHAT_HISTORY_LIMIT = 3;

export const CHAT_MAX_INPUT_LENGTH = 2000;
